import { render, staticRenderFns } from "./PowerupViewComponent.vue?vue&type=template&id=1c379fc6&scoped=true"
import script from "./PowerupViewComponent.vue?vue&type=script&lang=ts"
export * from "./PowerupViewComponent.vue?vue&type=script&lang=ts"
import style0 from "./PowerupViewComponent.vue?vue&type=style&index=0&id=1c379fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c379fc6",
  null
  
)

export default component.exports